import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { LinkComponent } from '../../link/link.component';

@Component({
  selector: 'app-display-rubrique-status-with-warning-and-cta',
  templateUrl: './display-rubrique-status-with-warning-and-cta.component.html',
  styleUrls: ['./display-rubrique-status-with-warning-and-cta.component.scss'],
  imports: [IonItem, IonLabel, IonList, LinkComponent],
})
export class DisplayRubriqueStatusWithWarningAndCtaComponent {
  @Input() title: string = '';
  @Input() warning: boolean = false;
  @Input() notWarning: string = '';
  @Input() ctaText: string = '';
  @Input() icon: string = '';
  @Input() pressable: boolean = true;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<void>();

  constructor() {}
}
